import React from 'react';
import PropTypes from 'prop-types';

/**
 * PageContainer - A standardized container component for consistent page layouts
 * 
 * Usage:
 * <PageContainer> - Standard 1200px width container
 * <PageContainer wide> - 1400px width for dashboard-style pages
 * <PageContainer narrow> - 800px width for forms and focused content
 * <PageContainer noPadding> - Remove default padding
 * <PageContainer noShadow> - Remove default shadow
 */
const PageContainer = ({ 
  children, 
  wide = false, 
  narrow = false, 
  noPadding = false, 
  noShadow = false,
  className = '',
  ...props 
}) => {
  // Determine container class based on props
  let containerClass = 'page-container';
  
  if (wide) {
    containerClass = 'page-container-wide';
  } else if (narrow) {
    containerClass = 'page-container-narrow';
  }
  
  // Add custom classes
  if (className) {
    containerClass += ` ${className}`;
  }
  
  // Apply conditional styling
  const containerStyle = {
    ...(noPadding && { padding: 0 }),
    ...(noShadow && { boxShadow: 'none' })
  };
  
  return (
    <div className={containerClass} style={containerStyle} {...props}>
      {children}
    </div>
  );
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  wide: PropTypes.bool,
  narrow: PropTypes.bool,
  noPadding: PropTypes.bool,
  noShadow: PropTypes.bool,
  className: PropTypes.string
};

export default PageContainer;
